




















































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  formData: { [t: string]: any } = {};

  data3: any[] = [];

  columns: any[] = [
    { title: "行为", dataIndex: "name" },
    { title: "操作次数", dataIndex: "value" },
    { title: "第一次时间", dataIndex: "min_time" },
    { title: "最后一次", dataIndex: "max_time" }
  ];

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("syslog/stadiumData", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    const res3 = await this.$store.dispatch("syslog/enterapplyData", {
      user_id: this.formData.manager_user_id
    });
    if (res3 && res3.Data) {
      this.data3 = res3.Data;
    }
    this.spinLoading = false;
  }
}
